/** Digits-only numeric value from a SCAR/ART7 index ID (hyphens and letters ignored). */
export const parseScarIndexNumeric = (v) => {
  const digits = String(v ?? '').replace(/\D/g, '');
  return digits === '' ? null : Number(digits);
};

/** Sort SCAR/ART7 index IDs by digits only (hyphens and letters ignored). */
export const scarIndexSortComparator = (v1, v2) => {
  const n1 = parseScarIndexNumeric(v1);
  const n2 = parseScarIndexNumeric(v2);
  if (n1 === null && n2 === null) return 0;
  if (n1 === null) return 1;
  if (n2 === null) return -1;
  return n1 - n2;
};
